<template>
  <div class="Emotions">
    <Emotion v-for="(w,k) in emotions" :key="k" :pos="pos[k]" :id="k" :txt="w" :oeuvre_id="oeuvre_id"/>
  </div>
</template>

<script>
import Emotion from './Emotion'
export default {
  name: 'Emotions',
  components: { Emotion },
  props: ['oeuvre_id'],
  data: () => ({ 
    emotions: [
    'merveilleux',
    'surpris',
    'curieux',
    'fache',
    'neutre',
    'content',
    'triste',
    'calme'
    ],
    pos: [
      [ -970, 40 ],
      [ -730, -140 ],
      [ 970, 40 ],
      [ 730, -140 ],
      [ -750, 250 ],
      [ -1100, -230 ],
      [ 750, 250 ],
      [ 1100, -230 ]

      // [ 510, -340 ],
      // [ -623, 338 ]
    ]
  }),
  mounted(){
    this.$parent.emotions = this.emotions 
  },
}
</script>

<style lang="stylus">
@import '~@/config/Settings'

.Emotions
  position absolute 
  top 0 
  left 0

</style>































































// WEBPACK FOOTER //
// src/components/defis/components/Emotions.vue